export const SET_IS_LOADING = 'OPEN_API_REGISTRATION/SET_IS_LOADING';
export const SET_TOKEN = 'OPEN_API_REGISTRATION/SET_TOKEN';
export const SET_ERRORS = 'OPEN_API_REGISTRATION/SET_ERRORS';
export const CLEAR_ERRORS = 'OPEN_API_REGISTRATION/CLEAR_ERRORS';